// extracted by mini-css-extract-plugin
export default {"cartContainer":"RS","summarycontent":"SS","offset":"TS","leaf":"US","summaryclosed":"VS","summaryheader":"WS","summaryitems":"XS","summaryprice":"YS","buttonopen":"ZS","buttondown":"aT","summaryfixed":"bT","usdnotification":"cT","renew":"eT","promowrapper":"fT","ordersummarywrap":"gT","simplewrap":"hT"};
    if(module.hot) {
      // 1715632478717
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  